module.exports = __webpack_public_path__ + "static/media/star_lop-y_90.0a4a1939.png";